import { render, staticRenderFns } from "./SaleTotal.vue?vue&type=template&id=3efb7f4b&scoped=true"
import script from "./SaleTotal.vue?vue&type=script&lang=js"
export * from "./SaleTotal.vue?vue&type=script&lang=js"
import style0 from "./SaleTotal.vue?vue&type=style&index=0&id=3efb7f4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb7f4b",
  null
  
)

export default component.exports